
















import { defineComponent } from '@vue/composition-api';

export default defineComponent({
    name: 'BootstrapModal',
    props: {
        id: { type: String, default: '' },
        title: { type: String, required: false },
        html: { type: String, required: false }
    },
    watch: {
        html (val) {
            if (val) {
                // jQuery.html() is used here because it can recognize and execute <script>
                // v-html doesn't execute <script>
                // see vehicle-project/engine/core/includes/tpl/view/speccheck_features.ihtml
                //
                // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                // @ts-ignore
                $(this.$refs.body).html(val);
            }
        }
    },
    setup (props, { refs, emit }) {
        const closeModal = () => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            $(refs.modal).modal('hide');
            emit('modal-closed');
        };
        return { closeModal };
    }
});
